{
	"required": "Required field",
	"passwordMustBeSame": "Passwords must be the same",
	"minLength": "Password must be at least {{count}} characters long",
	"passwordUppercase": "Password must contain at least one uppercase letter",
	"passwordLowercase": "Password must contain at least one lowercase letter",
	"passwordNumber": "Password must contain at least one number",
	"passwordSpecial": "Password must contain at least one special character"
}
